export const baseUrl = "https://abuamirstore-backend.devoracompany.com/api";

export const loginURL = "login";

export const productsURL ="/dashboard/products"

export const discountTimestampRangeURL="/dashboard/discount-timestamp-range"

export const categoriesURL ="/dashboard/categories"

export const subCatURL="/dashboard/categories/get-subs"

export const cmsURL="/dashboard/cms"

export const uploadImageURL="/dashboard/cms/upload-image"

export const discountCouponsURL="/dashboard/discount-coupons"

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "dashboard/clients";

export const employeesURL = "dashboard/employees";

export const usersURL = "users";

export const permissionsURL = "permissions";

export const notificationsURL = "notifications";


export const notificationsInfoURL="dashboard/info-notifications"

export const statisticsURL = "/dashboard/statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";

export const ordersURL = "/dashboard/orders";

export const advertisementsURL="/dashboard/advertisements"

export const storeInfoURL="/dashboard/store-info"

export const governoratesURL = "dashboard/countries";

export const areasURL = "dashboard/provinces";

export const shippingSettingsURL ="dashboard/shipping-setting"


